<h3 class="mb-3">{{ 'lombard.initial.explanation.headline' | transloco }}</h3>
<ng-template #explanationStep let-step="step">
  <div class="row mb-2">
    <div class="col d-flex align-items-center">
      <div class="mr-2">
        <svg class="icon icon-21 text-color-success">
          <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
        </svg>
      </div>
      <div class="text-size-large text-bold">{{ 'lombard.initial.explanation.step-' + step | transloco }}</div>
    </div>
  </div>
</ng-template>
@for (step of [1, 2, 3, 4]; track $index) {
  <ng-container *ngTemplateOutlet="explanationStep; context: { step: step }" />
}
